import React, { PureComponent } from "react";
// import { Link } from "react-router-dom";
// import { MakeTitle } from "../../utils/consts";

import CrossIcon from "@atlaskit/icon/glyph/cross";

import "./mapBoxPinPopup.css";
export default class MapBoxPinPopup extends PureComponent {
  render() {
    const { info } = this.props;
    return (
      <div className="mapbox-popup">
        <CrossIcon
          size="small"
          onClick={this.props.onClose}
          className="mapbox-closebtn"
        />
        <a
          className="mapbox-popup__link"
          target="_blank"
          href={`/listing/${info.lid}`}
        >
          {info.title}
          {}
          <div
            style={
              !!info.preview
                ? {
                    backgroundImage: `url(data:image/jpeg;base64,${
                      info.preview
                    })`,
                    height: "80px"
                  }
                : {}
            }
            className="mapbox-popup__img"
          />
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/mapBoxPinPopup/MapBoxPinPopup.js